/* Guide table of contents: builds a jump-link list from the article body headings and
   highlights the active one on scroll. Progressive enhancement — the TOC nav starts
   [hidden] and is only revealed once headings are found, so with JS off nothing shows
   and the article is unaffected. */
(function () {
  function slugify(text) {
    var s = (text || '').toLowerCase().trim()
      .replace(/[^\w\s-]/g, '')
      .replace(/\s+/g, '-')
      .replace(/-+/g, '-')
      .slice(0, 60);
    return s || 'section';
  }

  function init() {
    var toc = document.querySelector('[data-guide-toc]');
    var content = document.querySelector('.article-main__content');
    if (!toc || !content) return;
    var list = toc.querySelector('.guide-toc__list');
    if (!list) return;

    var selector = toc.getAttribute('data-toc-levels') === 'h2h3' ? 'h2, h3' : 'h2';
    var headings = content.querySelectorAll(selector);
    if (!headings.length) return;

    var links = {};
    var used = {};
    Array.prototype.forEach.call(headings, function (h) {
      if (!h.id) {
        var base = slugify(h.textContent), id = base, n = 2;
        while (document.getElementById(id) || used[id]) { id = base + '-' + n; n++; }
        h.id = id;
      }
      used[h.id] = true;
      var li = document.createElement('li');
      li.className = 'guide-toc__item guide-toc__item--' + h.tagName.toLowerCase();
      var a = document.createElement('a');
      a.className = 'guide-toc__link';
      a.href = '#' + h.id;
      a.textContent = h.textContent;
      li.appendChild(a);
      list.appendChild(li);
      links[h.id] = a;
    });

    toc.hidden = false;

    if ('IntersectionObserver' in window) {
      var obs = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            for (var id in links) { links[id].classList.remove('guide-toc__link--active'); }
            var active = links[entry.target.id];
            if (active) active.classList.add('guide-toc__link--active');
          }
        });
      }, { rootMargin: '0px 0px -75% 0px', threshold: 0 });
      Array.prototype.forEach.call(headings, function (h) { obs.observe(h); });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
